<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
    <path fill="#C93B3B" d="M15.924,4C14.414,4.011,12.982,4.676,12,5.822C11.018,4.677,9.589,4.013,8.081,4
     c-2.623-0.028-4.772,2.075-4.8,4.697c0,0.034,0,0.068,0,0.103c0,3.3,2.965,5.981,7.455,10.062L12,20l1.264-1.151
     c4.49-4.072,7.455-6.757,7.455-10.053C20.745,6.173,18.64,4.026,16.017,4C15.986,4,15.955,4,15.924,4z"/>
    </svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'heart-filled'
}
</script>
